(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/casino-grid/assets/javascripts/casino-grid-scrollable.js') >= 0) return;  svs.modules.push('/components/casino-react/casino-grid/assets/javascripts/casino-grid-scrollable.js');

'use strict';

const {
  forwardRef
} = React;
const CasinoGameCard = svs.components.casino_react.casinoGameCard.CasinoGameCard;
const CasinoProviderCard = svs.components.casino_react.casinoProviderCard.CasinoProviderCard;
const CasinoCategoryCard = svs.components.casino_react.casinoCategoryCard.CasinoCategoryCard;
const {
  constants: {
    CardType
  }
} = svs.components.casino_react.common;
const CasinoGridScrollable = forwardRef((_ref, ref) => {
  let {
    items
  } = _ref;
  return React.createElement("ul", {
    className: "casino-grid--scrollable",
    ref: ref
  }, items.map(item => React.createElement("li", {
    className: "casino-grid__scrollable-item",
    key: "item-".concat(item.model.name, "}")
  }, item.type === CardType.GAME && React.createElement(CasinoGameCard, {
    containedHover: true,
    gameName: item.model.name
  }), item.type === CardType.PROVIDER && React.createElement(CasinoProviderCard, {
    providerName: item.model.systemName
  }), item.type === CardType.CATEGORY && React.createElement(CasinoCategoryCard, {
    categoryName: item.model.systemName
  }))));
});
CasinoGridScrollable.propTypes = {
  items: PropTypes.array.isRequired
};
setGlobal('svs.components.casino_react.CasinoGridScrollable', CasinoGridScrollable);

 })(window);